// 2s de preview assistido: no mobile e o unico sinal de intencao antes do toque.
const ENGAGED_PREVIEW_MS = 2000;

export function useCardEngagement(options: {
	isVideoPlaying: Ref<boolean>;
	/** Instancia reusada com outro imovel precisa poder emitir de novo. */
	contentKey: Ref<string>;
	onEngaged: () => void;
}): void {
	let timer: ReturnType<typeof setTimeout> | undefined;
	let hasEmitted = false;

	watch(options.contentKey, () => {
		clearTimeout(timer);
		hasEmitted = false;
	});

	watch(options.isVideoPlaying, playing => {
		clearTimeout(timer);
		if (!playing || hasEmitted) return;
		timer = setTimeout(() => {
			hasEmitted = true;
			options.onEngaged();
		}, ENGAGED_PREVIEW_MS);
	});

	onUnmounted(() => clearTimeout(timer));
}
